import { FormContent } from '@agent/agent-interface/contact-view/contact-display-qualification.component.ajs';
import { AppointmentQualificationStatus } from '@agent/core/contact/appointment-deprecated.service';
import { IAppointment } from '@commons/models/appointment';

import { Option, QualifField, QualificationService } from '@contact/upgrade';

export interface IAppointmentQualification {
  /**
   *contact appointment uri (phone number)
   * @type {string}
   */
  contactUri: string;
  /**
   *uuid of the customer card
   * @type {string}
   */
  contactUuid: string;
  /**
   * external id of the contact
   * @type {string}
   */
  contactId: string;
  /**
   *contact firstname
   * @type {string}
   */
  contactFirstName: string;
  /**
   *contact lastname
   * @type {string}
   */
  contactLastName: string;
  /**
   *media entry point uuid associated to campaign
   * @type {string}
   */
  mediaEntryPointUuid: string;
  /**
   *post treament form content
   * @type {InteractionContentDto}
   */
  interactionContent: InteractionContentDto;
  /**
   *list of skills associated to the appointment
   * @type {string[]}
   */
  skillUuidList: string[];
  /**
   *uuid of the campaign
   * @type {string}
   */
  campaignId: string;
  /**
   *name of the campaign
   * @type {string}
   */
  campaignName: string;
  /**
   * @type {AppointmentQualificationStatus}
   */
  status: AppointmentQualificationStatus;
}

export enum InteractionType {
  PRIMARY,
  SECONDARY,
  LINKED,
}

export enum ContactEntryContentType {
  FORM,
  SMS,
  MAIL,
  CAMPAIGN_INFO,
  SURVEY,
}

export interface InteractionContentDto {
  content: string;
  parentUuid: string;
  interactionType: string;
  media: string;
  subject: string;
}

/**
 * corrspond to net.awl.od.cng.business.communication.dto.rest.csr.AppointmentQualificationDto in business
 * used to close an appointment in campaign and create a contact entry with given fields
 */
export class AppointmentQualificationDto implements IAppointmentQualification {
  contactUri: string;
  contactUuid: string;
  contactId: string;
  contactFirstName: string;
  contactLastName: string;
  mediaEntryPointUuid: string;
  interactionContent: InteractionContentDto;
  skillUuidList: string[];
  campaignId: string;
  campaignName: string;
  status: AppointmentQualificationStatus;

  private static computeFormValues(fields: QualifField[]): FormContent[] {
    let result: FormContent[] = [];
    fields.forEach(f => {
      if (f.controlType === 'input') {
        result.push({
          key: f.id,
          value: Option.of(f.value as string).getOrElse(''),
        });
      } else if (f.value && QualificationService.isFieldSelect(f.value)) {
        result.push({
          key: f.id + '.' + Option.of(f.value.id).getOrElse(''),
          value: Option.of(f.value.value).getOrElse(''),
        });
      }
    });
    return result;
  }

  /**
   * create an AppointmentQualification from ihm form data input and appointment
   * @param data the appointment data
   * @param fields the list of valued fields
   */
  static fromData(data: IAppointment, fields: QualifField[], status: AppointmentQualificationStatus): IAppointmentQualification {
    return {
      contactUri: data.phone,
      contactUuid: data.customerCardUuid,
      contactId: data.externalContactId,
      contactFirstName: data.firstName,
      contactLastName: data.lastName,
      mediaEntryPointUuid: (data.campaign.stream && data.campaign.stream.uuid) || '',
      skillUuidList: data.skillList.map(s => s.id),
      campaignId: data.campaign.id,
      campaignName: data.campaign.name,
      status: status,
      interactionContent: {
        content: JSON.stringify(AppointmentQualificationDto.computeFormValues(fields)),
        parentUuid: '',
        interactionType: InteractionType[InteractionType.PRIMARY],
        media: ContactEntryContentType[ContactEntryContentType.FORM],
        subject: '',
      },
    } as IAppointmentQualification;
  }
}
